<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Farm</a></li>
          <li><a>Traceability Summary</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home" *ngIf="loginUserBusinessCategory != 'Provider'"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
          <a routerLink="/home/dashboard" *ngIf="loginUserBusinessCategory == 'Provider'"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Traceability Summary</span>
        </div>
        <div class="Reports_form_div">
          <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="registerForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
                <mat-label>Search Business Name</mat-label>
                <!-- search box powered by mat‑autocomplete -->
                <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                       placeholder="Search business" (keyup)="filterBusinesses($event)"
                       (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                       [matAutocomplete]="businessAuto"/>
                <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{ option.businessName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100" *ngIf="loginPersonType == 'Provider Manager'">
                <mat-label>Technician</mat-label>
                <mat-select id="businessfield" formControlName="businessfield" name="businessfield" (click)="isDropdownOpen = false"
                            [(ngModel)]="pondCulture.person_id" (selectionChange)="getFarmSitesByTechnicianId()">
                  <mat-option value="undefined" disabled>Select Technician</mat-option>
                  <mat-option *ngFor="let tech of persons" [value]="tech.id">
                    {{ (tech?.firstName) }} {{tech.lastName}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select technician</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Technician selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false"
                            [(ngModel)]="pondCulture.farm_site_id" (selectionChange)="getSetionsByFarmsiteId(pondCulture.farm_site_id)">
                  <mat-option value="undefined" disabled>Select Farm site</mat-option>
                  <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                    {{ (farmsite?.farmNameAtLocation) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
                <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                  <i *ngIf="f.locationField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <!--<div class="form-field">
                <select id="location" [(ngModel)]="pondCulture.farm_site_id" class="form-control select"
                        [ngClass]="{ 'is-invalid': submitted && f.locationField.errors }"
                        (change)="getSetionsByFarmsiteId(pondCulture.farm_site_id)"
                        formControlName="locationField" (click)="isDropdownOpen = false">
                  <option value="undefined" disabled selected>Select Farm Site</option>
                  <option value="{{site.id}}"
                          *ngFor="let site of farmSites">{{site.farmNameAtLocation}}</option>
                </select>
                <label for="location">Farm Site</label>
                <span class="custom-arrow"></span>
                <div *ngIf="submitted && f.locationField.errors">
                  <div *ngIf="f.locationField.errors.required" class="field-validation-error-message">
                    <img src="../../../../../../assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                    <span>Required</span>
                  </div>
                </div>
              </div>-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select Section</mat-label>
                <mat-select id="section" formControlName="sectionField" name="section" (click)="isDropdownOpen = false"
                            [(ngModel)]="pondCulture.section_id" (selectionChange)="getPondsBySectionId(pondCulture.section_id)">
                  <mat-option value="undefined" disabled>Select Section</mat-option>
                  <mat-option *ngFor="let section of pondSections" [value]="section.id">
                    {{ (section?.section_name) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.sectionField.invalid"><i>Select section</i></mat-hint>
                <mat-hint *ngIf="f.sectionField.valid"><i>Section selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.sectionField.touched || f.sectionField.dirty) && f.sectionField.errors">
                  <i *ngIf="f.sectionField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <!--<div class="form-field">
                <select id="section" [(ngModel)]="pondCulture.section_id" class="form-control select"
                        (change)="getPondsBySectionId(pondCulture.section_id)"
                        formControlName="sectionField" (click)="isDropdownOpen = false">
                  <option value="undefined" disabled selected>Select Section</option>
                  <option value="{{sections.id}}"
                          *ngFor="let sections of pondSections">{{sections.section_name}}</option>
                </select>
                <label for="location">Section</label>
                <span class="custom-arrow"></span>
                <div *ngIf="submitted && f.sectionField.errors">
                  <div *ngIf="f.sectionField.errors.required" class="field-validation-error-message">
                    <img src="../../../../../../assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                    <span>Required</span>
                  </div>
                </div>
              </div>-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Select Pond</mat-label>
                <mat-select id="pond" formControlName="pondField" name="pond" (click)="isDropdownOpen = false"
                            [(ngModel)]="pondCulture.pond_id" (selectionChange)="getCulturesByPondId(pondCulture.pond_id)">
                  <mat-option value="undefined" disabled>Select Pond</mat-option>
                  <mat-option *ngFor="let pond of pondsDetails_dropdown" [value]="pond.pond_id">
                    {{ (pond.pond_name) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.pondField.invalid"><i>Select pond</i></mat-hint>
                <mat-hint *ngIf="f.pondField.valid"><i>Pond selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.pondField.touched || f.pondField.dirty) && f.pondField.errors">
                  <i *ngIf="f.pondField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="traceabilityReport()">
              <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                <span class="text">Search</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="responseLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
         <div class="reports_block" *ngIf="!responseLoader && isSubmitClicked && dupPondTraceabilities?.length > 0">
          <div class="actions-container">
            <div class="search-div">
              <img src="../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (keyup)="onFiltersApplied()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by pond type and culture type">
              <button *ngIf="this.search != ''"  type="button" (click)="clearFilters('search')" title="clear search" class="searchClose">&times;</button>
            </div>

            <div class="action-icons" *ngIf="pondTraceabilitiesData?.length > 0">
              <img src="../../../../assets/images/New_Icons/excel-download-icon.svg" title="Excel downlaod" (click)="exportExcel()">
              <img src="../../../../assets/images/New_Icons/expand-icon.svg" title="Zoom in" (click)="openFullScreen()">
            </div>
          </div>
          <div class="table-responsive" id="zoomView" *ngIf="pondTraceabilitiesData?.length > 0">
            <table class="table table-striped table-bordered table-hover text-centre">
              <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Pond Type</th>
                <th>Culture Type</th>
                <th>Density(pl/m2)</th>
                <th>Feed Given</th>
                <th>Feed Mix</th>
                <th>Treatments</th>
                <th>Sampling</th>
                <th>Observation</th>
                <th>Water Quality</th>
                <th>Harvest</th>
                <th>Weather</th>
                <th>Lunar</th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="let list of pondTraceabilitiesData; let i = index;">
                <td>{{i + 1}}</td>
                <td>{{list.Dates | date:"dd MMM yyyy"}}</td>
                <td>{{list.PondType == null ? 'NA' : list.PondType}}</td>
                <td>{{list.CultureType == null ? 'NA' : list.CultureType}}</td>
                <td class="number-align-right">{{list.Density == null ? 'NA' : list.Density}}</td>
                <td class="number-align-right">{{list.feed_given == null ? 'NA' : list.feed_given}}</td>
                <td class="number-align-right">{{list.Feedmix == null ? 'NA' : list.Feedmix}}</td>
                <td class="number-align-right">{{list.Treatment == null ? 'NA' : list.Treatment}}</td>
                <td class="number-align-right">{{list.Sampling == null ? 'NA' : list.Sampling}}</td>
                <td class="number-align-right">{{list.Observation == null ? 'NA' : list.Observation}}</td>
                <td class="number-align-right">{{list.WaterQuality == null ? 'NA' : list.WaterQuality}}</td>
                <td class="number-align-right">{{list.Harvest == null ? 'NA' : list.Harvest}}</td>
                <td>{{list.weather == null ? 'NA' : list.weather}}</td>
                <td>{{(list && list.lunarEvent && list.lunarEvent.length > 0 && list.lunarEvent[0].event) || 'NA'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <div *ngIf="pondTraceabilitiesData?.length <= 0" class="noDataFoundMessage">
            {{search != '' && isCultureSelected ? 'No items match your search and filter' : (search != '' ? 'No items match your search' : 'No items match your filter')}}
          </div>
        </div>
        <div class="reports_block" *ngIf="dupPondTraceabilities?.length <= 0 && isSubmitClicked">
          <div class="noDataFoundMessage">Data Not Available</div>
        </div>
      </div>
    </div>
  </div>
</div>
